import { FieldValue } from '@ahmdigital/form-validation/lib/validators/types';
import { isNil } from 'lodash/fp';

import { MAX_AGE, MIN_AGE } from '../../../../data/constants';

const ageValidationBuilder = (errorMessages: { empty: string; max: string; min: string }) => (value?: FieldValue) => {
  if (isNil(value)) return errorMessages.empty;
  if (Number(value) > MAX_AGE) return errorMessages.max;
  if (Number(value) < MIN_AGE) return errorMessages.min;
  return null;
};

export default ageValidationBuilder;
